import React from "react";
import { Stack } from "expo-router";
import Constants from "expo-constants";
import { Colors } from "@/constants/Colors";
import useWindow from "@/hooks/useWindow";

const OffersLayout = () => {
  const { isDesktop } = useWindow();
  return (
    <Stack
      screenOptions={{
        contentStyle: {
          paddingTop: Constants.statusBarHeight,
          backgroundColor: Colors.background,
          width: isDesktop ? 600 : undefined,
          alignSelf: isDesktop ? "center" : undefined,
        },
      }}
    >
      <Stack.Screen name="index" options={{ headerShown: false }} />
      <Stack.Screen name="success" options={{ headerShown: false }} />
    </Stack>
  );
};

export default OffersLayout;
